import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import HandleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/HandleIconPath";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import styles from "./SortableItem.module.css";
import { getImageKey } from "../helpers";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

interface SortableItemProps {
  image: File;
  images: File[];
  onRemove: (image: File) => void;
}

export default function SortableItem({
  image,
  images,
  onRemove,
}: SortableItemProps) {
  const key = getImageKey(image);
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: key });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      {...attributes}
      className={styles["imageRow"]}
    >
      <div className={styles["imageRowInner"]}>
        {images.length > 1 && (
          <div {...listeners} className={styles["dragHandle"]} tabIndex={0}>
            <FixaSSRIcon paths={HandleIconPath} />
          </div>
        )}
        <div>
          <img
            className={styles["image"]}
            src={URL.createObjectURL(image)}
            alt={image.name}
            onLoad={(e) =>
              URL.revokeObjectURL((e.target as HTMLImageElement).src)
            }
          />
        </div>
        <FixaText textStyle="Body.M" className={styles["imageName"]}>
          {image.name.toLocaleUpperCase()}
        </FixaText>
        <FixaButton
          iconOnly
          ssrIcon={TrashCanIconPath}
          onClick={() => onRemove(image)}
          size="small"
          className={styles["removeButton"]!}
          data-testid="remove-image-button"
        />
      </div>
    </div>
  );
}
